import React from 'react';

export const ExclamationMarkIcon = ({
  className,
  width = 16,
  height = 16,
  color,
}) => (
  <svg
    data-testid="exclamation-mark-icon"
    className={className}
    width={width}
    height={height}
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M8 16C12.4183 16 16 12.4183 16 8C16 3.58172 12.4183 0 8 0C3.58172 0 0 3.58172 0 8C0 12.4183 3.58172 16 8 16ZM7.99999 8.99999C7.79311 9.00505 7.59232 8.92974 7.43979 8.78989C7.28726 8.65004 7.19486 8.45653 7.18199 8.24999L6.99999 4.49999C6.99712 4.36788 7.02103 4.23656 7.07027 4.11394C7.11951 3.99132 7.19306 3.87994 7.2865 3.7865C7.37993 3.69307 7.49132 3.61951 7.61394 3.57027C7.73656 3.52103 7.86788 3.49712 7.99999 3.49999C8.13261 3.49709 8.26444 3.52118 8.38747 3.57079C8.5105 3.6204 8.62217 3.69449 8.71569 3.78857C8.80921 3.88265 8.88264 3.99476 8.93151 4.11809C8.98038 4.24141 9.00368 4.37338 8.99999 4.50599L8.81299 8.25199C8.79965 8.45729 8.70773 8.64956 8.55633 8.78885C8.40493 8.92815 8.20568 9.00377 7.99999 8.99999ZM8 12.5C8.55229 12.5 9 12.0523 9 11.5C9 10.9477 8.55229 10.5 8 10.5C7.44772 10.5 7 10.9477 7 11.5C7 12.0523 7.44772 12.5 8 12.5Z"
      fill={color || 'currentColor'}
    />
  </svg>
);
